/**
 * HQ-2026-009 — cửa vào Sentry của dashboard. Không DSN (máy dev, build chưa khai `VITE_SENTRY_DSN`) ⇒ mọi hàm
 * ở đây là no-op và `@sentry/react` không bao giờ được tải.
 */

type Impl = typeof import("./sentry-impl.js");

let loading: Promise<Impl | null> | null = null;

function dsn(): string {
  const raw = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  return raw?.trim() ?? "";
}

function load(): Promise<Impl | null> {
  loading ??= import("./sentry-impl.js")
    .then((m) => {
      m.init();
      return m;
    })
    .catch((error: unknown) => {
      // Tải SDK hỏng (mạng, chặn quảng cáo) không được làm hỏng trang — nhưng phải để lại dấu.
      console.warn("[hq] Sentry SDK failed to load", error);
      return null;
    });
  return loading;
}

/** Gọi sớm nhất có thể ở `main.tsx`: lỗi xảy ra trước khi SDK sẵn sàng thì `window.onerror` của SDK không thấy. */
export function initSentryClient(): void {
  if (dsn()) void load();
}

/** Lỗi do chính giao diện bắt được (vd. `errorElement` của router) — SDK không tự thấy vì React đã nuốt nó. */
export function reportUiError(error: unknown, context?: Record<string, unknown>): void {
  if (!dsn()) return;
  void load().then((m) => m?.capture(error, context));
}
